export const CREATE_TAG = 'CREATE_TAG';
export const LIST_TAGS = 'LIST_TAGS';
export const EDIT_TAGS = 'EDIT_TAGS';
export const DELETE_TAGS = 'DELETE_TAGS';

export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const LIST_ORDER_REQUESTS = 'LIST_ORDER_REQUESTS';
export const EDIT_ORDER_REQUESTS = 'EDIT_ORDER_REQUESTS';
export const DELETE_ORDER_REQUESTS = 'DELETE_ORDER_REQUESTS';
